import React from "react";
import { Route, Routes } from "react-router-dom";
import Loginpage from "../Pages/Login/Loginpage";
import Dashboardpage from "../Pages/Dashboard/Dashboard";
import MainHomeLayout from "../Pages/MainHomeLayout";
import CustReg from "../Pages/CustomerReg/CustReg";
import OTPAuthPage from "../Pages/Booking/OTPAuthpage";
import NewTicketBooking from "../Pages/Booking/NewBooking";
import AddOfferPage from "../Pages/OfferPage/AddOffer";
import EditOfferPage from "../Pages/OfferPage/EditOffer";
import OfferListPage from "../Pages/OfferPage/Offers";
import ResetPassword from "../Pages/Login/ResetPassword";
import CustomerList from "../Pages/CustomerReg/CustomerList";
import UserpasswordReset from "../Pages/Login/UserpasswordReset";
import BookingListPage from "../Pages/Booking/BookingList";

const PageRoutes = () => {
  return (
    <Routes>
      <Route>
        <Route path="/" element={<Loginpage />}></Route>
        <Route path="/resetpassword" element={<ResetPassword />} />
      </Route>
      <Route element={<MainHomeLayout />}>
        <Route path="/dashboardpage" element={<Dashboardpage />} />
        <Route path="/custreg" element={<CustReg />} />
        <Route path="/NewTicketBooking" element={<NewTicketBooking />} />
        <Route path="/OTPAuthPage" element={<OTPAuthPage />} />
        <Route path="/AddOfferPage" element={<AddOfferPage />} />
        <Route path="/EditOfferPage/:offerId" element={<EditOfferPage />} />
        <Route path="/offers" element={<OfferListPage />} />
        <Route path="/customers" element={<CustomerList />} />
        <Route path="/resetuserpassword" element={<UserpasswordReset />} />        
     <Route path="/bookings" element={<BookingListPage />} />
        
      </Route>
    </Routes>
  );
};

export default PageRoutes;
